import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';
import { jobOffer } from 'job/model/job-offer.fragments';
import { tasksParticipant } from 'task/model/task.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { TaskOutput } from '../model/task.output';

export interface CreateTodoTaskInput {
	readonly taskDueTimestamp: number;
	readonly todoTitle: string;
	readonly todoDescription: string;
}

export interface CreateTodoTaskParams {
	input: CreateTodoTaskInput;
}

@Injectable({ providedIn: 'root' })
export class CreateTodoTaskApiMutation extends ApiMutation<
	TaskOutput,
	CreateTodoTaskParams
> {
	client = 'iam';
	document = gql`
		mutation CreateTodoTask($input: CreateTodoTaskInput!) {
			createTodoTask(input: $input) {
				id
				done
				type
				owner {
					id
				}
				contact {
					...Contact
				}
				jobOffer {
					...JobOffer
				}
				modulesId
				todoTitle
				dueTimestamp
				updateTimestamp
				participants {
					...TasksParticipant
				}
				todoDescription
			}
		}
		${tasksParticipant}
		${jobOffer}
		${contact}
	`;
	method = 'createTodoTask';
}
